var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { breakpoints } from '@local/styleguide';
import { ParamService } from './param.service';
import { screenSize } from './screen.factory';
import { styleParentElement, createSideBar, createPopupElement, pageHeader, companyTitle } from './html.factory';
import { DataService } from './data.service';
import { switchTopic, toggleSubMenu, openMenu, closeMenu, } from './menu.factory';
import { armLanguageSelector, setLanguageTag, switchLanguage } from './language.factory';
import { NavService, navItems } from './nav.service';
export class DashboardController {
    constructor() {
        this.params = new ParamService();
        this.data = new DataService();
        this.nav = new NavService(this);
        this.init();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.window = window;
            let selector = null;
            let segment = '2022';
            this.params.renew();
            this._reloadHtml();
            yield this.call(segment, false);
            const c = this.data.collection();
            this._reloadHtml();
            if (this.params.topic == 'company') {
                this._toggleSubMenu();
            }
            this._armMenuButton();
            armLanguageSelector(this);
            this._screenListener();
        });
    }
    call(segment, update) {
        return __awaiter(this, void 0, void 0, function* () {
            this.htmlContainer.innerHTML = "";
            let navItem = navItems.find(i => i.slug == this.params.topic);
            navItem = (navItem == undefined) ? navItems[0] : navItem;
            const pageTitle = this.params.language == 'en' ? navItem.title_en : navItem.title;
            pageHeader(pageTitle, this.htmlContainer);
            yield import(/*webpackIgnore: true*/ `./${this.params.topic}.bundle.js`);
            // @ts-ignore
            const ctrlr = new window[this.params.topic](this);
            ctrlr.init();
            return;
        });
    }
    switch(paramKey, paramValue) {
        closeMenu();
        switchTopic(this, paramKey, paramValue);
        companyTitle(this);
        if (this.params.topic === 'bedrijf') {
            this._toggleSubMenu();
        }
        this._closeMenu();
        return false;
    }
    switchLanguage(lan) {
        this.params.language = lan;
        switchLanguage(this);
        this.init();
    }
    _toggleSubMenu() {
        toggleSubMenu();
    }
    _reloadHtml() {
        setLanguageTag(this.params.language);
        this.htmlContainer = styleParentElement();
        [].slice.call(document.getElementsByTagName("aside")).forEach((a) => a.remove());
        [].slice.call(document.getElementsByTagName("nav")).forEach((a) => a.remove());
        const menu = this.nav.create();
        if (window.innerWidth < breakpoints.lg) {
            const nav = document.getElementById("mobile-menu");
            nav.appendChild(menu);
        }
        else {
            let aside = createSideBar(this.htmlContainer);
            aside.insertBefore(menu, aside.childNodes[0]);
        }
        this.nav.update();
        companyTitle(this);
        createPopupElement();
    }
    _screenListener() {
        const self = this;
        const screen = screenSize(window.innerWidth);
        window.addEventListener("resize", () => {
            let newScreen = screenSize(window.innerWidth);
            if (screen != newScreen) {
                setTimeout(() => {
                    self._reloadHtml();
                }, 100);
            }
        }, false);
    }
    _armMenuButton() {
        this.open_btn = document.getElementById('mobile-menu-item-open');
        this.close_btn = document.getElementById('mobile-menu-item-close');
        this.open_btn.addEventListener(("click"), () => {
            this._openMenu();
        });
        this.close_btn.addEventListener(("click"), () => {
            this._closeMenu();
        });
    }
    _openMenu() {
        const ariaExpanded = this.open_btn.querySelector('button').getAttribute('aria-expanded');
        const isExpanded = ariaExpanded === 'true';
        // this.open_btn.classList.toggle('close');
        console.log(1);
        if (!isExpanded) {
            console.log(2);
            openMenu();
        } // else {
        //     closeMenu(); 
        // }
        this.open_btn.querySelector('button').setAttribute('aria-expanded', !isExpanded);
        this.close_btn.querySelector('button').setAttribute('aria-expanded', !isExpanded);
        this.close_btn.style.display = "flex";
        this.open_btn.style.display = "none";
    }
    _closeMenu() {
        const ariaExpanded = this.close_btn.querySelector('button').getAttribute('aria-expanded');
        const isExpanded = ariaExpanded === 'true';
        // this.close_btn.classList.toggle('close');
        if (!isExpanded) {
            // openMenu();
        }
        else {
            closeMenu();
        }
        this.open_btn.querySelector('button').setAttribute('aria-expanded', !isExpanded);
        this.close_btn.querySelector('button').setAttribute('aria-expanded', !isExpanded);
        this.open_btn.style.display = "flex";
        this.close_btn.style.display = "none";
    }
}
